import { useContext, useEffect, useCallback, useState } from 'react';
import { CartContext } from '../../store/CartContext';
import useBrand from '../../hooks/useBrand';
import { useNavigate } from 'react-router';
import cookies from '../../utils/cookies';
// import CouponField from './CouponField';

// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
CheckoutBtn.propTypes = {
  label: PropTypes.string,
  nextPage: PropTypes.string,
};

export default function CheckoutBtn({ label = 'Checkout Now', nextPage = null }) {
  const [cartState, cartDispatch] = useContext(CartContext);
  const isCartLoading = cartState.isLoading;
  const isUpdatingBillingInfo = cartState.isUpdatingBillingInfo;
  const isCartValid = Object.keys(cartState.validation.errors).length === 0;
  const { domain } = useBrand();
  const vehicleMaintenancePID = '6264d1fd-7607-42f2-9667-3b4f24957e07';

  const navigate = useNavigate();

  const VITE_APP_MODE = import.meta.env.MODE;
  const NODE_ENV = process.env.NODE_ENV.toLowerCase();
  const isDevMode = import.meta.env.DEV;

  let shopUrl = `https://dlshop.${domain}`;

  // Check if the hostname contains a subdomain
  const isSubdomain = domain.split('.').length > 2;
  const separator = isSubdomain ? '-' : '.';

  if (VITE_APP_MODE === 'localDev' && isDevMode) {
    shopUrl = `https://shop${separator}${domain}`;
  }
  if (VITE_APP_MODE === 'staging' && isDevMode) {
    shopUrl = `https://mlshop${separator}${domain}`;
  }

  if (NODE_ENV === 'staging') {
    shopUrl = `https://mlshop${separator}${domain}`;
  }
  if (NODE_ENV === 'production') {
    shopUrl = `https://shop${separator}${domain}`;
  }

  const [isClicked, setIsClicked] = useState(false);

  const checkUrl = nextPage ? nextPage : `${shopUrl}/checkout/?cartId=${cartState.cartId}`;

  const currentProduct = cartState.cartProducts?.[0] || null;
  const vehicleMaintenanceUpsell = currentProduct?.upSellProducts?.find(
    (upsell) => upsell.productId === vehicleMaintenancePID
  );
  const hasVehicleMaintenanceUpsell = Boolean(vehicleMaintenanceUpsell);
  const isVehicleMaintenanceUpsellSelected = Boolean(vehicleMaintenanceUpsell?.isSelected);

  // this should be set/coming from Convert, this is what will trigger the upsell modal
  const useVehicleMaintenanceModal = cookies.get('testVariant') === 'useVehicleMaintenanceModal';
  // const useVehicleMaintenanceModal = true; // for testing only!!!

  const seenKey = `vmModalSeen-${cartState.cartId}`;
  const shouldShowVmModal =
    !nextPage &&
    hasVehicleMaintenanceUpsell &&
    !isVehicleMaintenanceUpsellSelected &&
    sessionStorage.getItem(seenKey) !== 'true' &&
    useVehicleMaintenanceModal &&
    cartState?.cartProducts?.length === 1;

  const handleNextPage = useCallback(() => {
    if (!isCartValid) {
      cartDispatch({
        type: 'VALIDATION',
        payload: {
          showErrors: true,
          formTouched: true,
        },
      });
      return;
    }
    // For checkout button flow only
    if (shouldShowVmModal) {
      sessionStorage.setItem(seenKey, 'true');
      cartDispatch({
        type: 'EXPERIENCE',
        payload: { showUpsellModal: true },
      });
      return;
    }
    // otherwise continue normal behavior
    if (!nextPage) {
      sessionStorage.setItem('viewCheckout', true);
      // hide the upsell modal
      cartDispatch({
        type: 'EXPERIENCE',
        payload: { showUpsellModal: false },
      });
      window.location.href = checkUrl;
    } else {
      window.scrollTo(0, 0);
      navigate(checkUrl);
    }
  }, [isCartValid, nextPage, checkUrl, navigate, cartDispatch, shouldShowVmModal, seenKey]);

  // this triggers the checkout or the next page navigation
  useEffect(() => {
    if (!isUpdatingBillingInfo && isClicked) {
      handleNextPage();
      setIsClicked(false);
    }
  }, [handleNextPage, isClicked, isUpdatingBillingInfo]);

  // using state to track if the button is clicked
  // so that we can wait for the user info update to finish
  // before we trigger the checkout or the next page navigation
  // this is to prevent the button from being clicked multiple times
  // or trigger the next page view if the next page url is provided
  const handleClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    setIsClicked(true);
  };

  return (
    <button
      type="button"
      className={`checkout-btn btn btn-lg btn-success w-100 py-3 py-md-2 ${isCartLoading ? 'disabled' : ''} ${
        isClicked && isCartValid ? 'btn-processing' : ''
      }`}
      onClick={handleClick}
      name={label}
    >
      <span className="btn-label">{label}</span>
    </button>
  );
}
